import { useState, useEffect } from 'react'

const SplitBorderCircle = ({ activeSections = 3, activeColor = 'yellow', inactiveColor = 'darkgray' }) => {
	const [rotation, setRotation] = useState(0)
	const circleRadius = 60
	const strokeWidth = 10
	const gapAngle = 10
	const arcLength = (360 - 3 * gapAngle) / 3
	const startAngles = [0, arcLength + gapAngle, 2 * (arcLength + gapAngle)].map((angle) => angle + gapAngle / 2)
	const singleSectionAngle = 30

	useEffect(() => {
		if (activeSections === 1) {
			setRotation(singleSectionAngle - startAngles[0])
		} else {
			setRotation((prev) => prev + 120)
		}
	}, [activeSections])

	const polarToCartesian = (centerX: number, centerY: number, radius: number, angleInDegrees: number) => {
		const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0
		return {
			x: centerX + radius * Math.cos(angleInRadians),
			y: centerY + radius * Math.sin(angleInRadians),
		}
	}

	const describeArc = (x: number, y: number, radius: number, startAngle: number, endAngle: number) => {
		const start = polarToCartesian(x, y, radius, endAngle)
		const end = polarToCartesian(x, y, radius, startAngle)
		const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'
		return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ')
	}

	return (
		<svg
			viewBox="0 0 220 220"
			style={{
				width: '100%',
				height: '100%',
				display: 'block',
				transform: `rotate(${rotation}deg)`,
				transformOrigin: '50% 50%',
				willChange: 'transform',
				transition: 'transform 0.5s ease-in-out',
			}}>
			{startAngles.map((startAngle, index) => (
				<path
					key={index}
					d={describeArc(110, 110, circleRadius, startAngle, startAngle + arcLength)}
					fill="none"
					stroke={index < activeSections ? activeColor : inactiveColor}
					strokeWidth={strokeWidth}
					style={{ transition: 'stroke 0.5s ease-in-out' }}
				/>
			))}
		</svg>
	)
}

export default SplitBorderCircle
